export default __webpack_public_path__ + "static/media/starRoundGolden.1e0d42ac.svg";